import { Callout } from '../../../../../components/Callout';
import { CustomFormattedMessage } from '../../../../../i18n/i18n';

type ExpiringCardsCalloutProps = {
  cardsExpiring: string[];
  onClick: () => void;
  onClose: () => void;
};

export const ExpiringCardsCallout = ({
  cardsExpiring,
  onClose,
  onClick,
}: ExpiringCardsCalloutProps) => (
  <Callout
    data-testid="your-insights-expiring-cards"
    type="warning"
    title={
      <CustomFormattedMessage
        id={
          cardsExpiring.length !== 1
            ? 'overview.yourSimplePay.expiringCards.title.plural'
            : 'overview.yourSimplePay.expiringCards.title.singular'
        }
        values={{ count: cardsExpiring.length }}
      />
    }
    description={
      <CustomFormattedMessage
        id={
          cardsExpiring.length !== 1
            ? 'overview.yourSimplePay.expiringCards.description.plural'
            : 'overview.yourSimplePay.expiringCards.description.singular'
        }
        values={{ cards: cardsExpiring.join(', ') }}
      />
    }
    onClick={onClick}
    onClose={onClose}
  />
);
